import { User } from '../../auth/types/auth';
import { Diagnostic } from '../types/diagnostic';
import { Preferences } from '../../auth/types/preferences.type';
import { diagnosticFactory } from './diagnostic.factory';
import { getPipeline } from './get-pipeline.util';

export const getUserDiagnostic = (
  diagnostics: Diagnostic[],
  user: User,
  userPreferences: Preferences,
): Diagnostic => {
  const userDiagnostic = diagnostics.find(
    ({ expertId, annotationTable }) =>
      user.id === expertId &&
      userPreferences.annotationTable === annotationTable,
  );

  return (
    userDiagnostic ??
    diagnosticFactory({
      expertId: user.id,
      expertName: user.name,
      pipeline: getPipeline(diagnostics),
    })
  );
};
